'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toBool = exports.hasSize = exports.isTrue = exports.isFalse = undefined;

var _identical2 = require('lodash/fp/identical');

var _identical3 = _interopRequireDefault(_identical2);

var _stubTrue2 = require('lodash/stubTrue');

var _stubTrue3 = _interopRequireDefault(_stubTrue2);

var _negate2 = require('lodash/negate');

var _negate3 = _interopRequireDefault(_negate2);

var _isObject2 = require('lodash/isObject');

var _isObject3 = _interopRequireDefault(_isObject2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _cond2 = require('lodash/cond');

var _cond3 = _interopRequireDefault(_cond2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Returns true if sent a value that is exactly false.
var isFalse = exports.isFalse = (0, _identical3.default)(false);
var isTrue = exports.isTrue = (0, _identical3.default)(true);
var hasSize = exports.hasSize = (0, _negate3.default)(_isEmpty3.default);
// Turn empty objs and arrays to false. Turn other vals into a boolean.
var toBool = exports.toBool = (0, _cond3.default)([[_isObject3.default, hasSize], [_stubTrue3.default, Boolean]]);


//////////////////
// WEBPACK FOOTER
// ./~/cape-lodash/lib/bool.js
// module id = 662
// module chunks = 0